import React from 'react';
import { Skeleton } from 'antd';

export type DashboardAiScenariosHeaderProps = {
    theme: 'dark' | 'light';
    resultCardMinimized: boolean;
    aiLoading: boolean;
};

/**
 * Loading skeleton only — tab rail already shows “AI designs”; avoid duplicate headings and extra chrome.
 */
export const DashboardAiScenariosHeader: React.FC<DashboardAiScenariosHeaderProps> = ({
    theme,
    resultCardMinimized,
    aiLoading,
}) => {
    if (resultCardMinimized || !aiLoading) {
        return null;
    }

    return (
        <div
            className="editor-ai-scenarios-header-loading"
            style={{
                padding: '12px 0 8px',
                fontSize: 13,
                color: theme === 'dark' ? 'rgba(148,163,184,0.9)' : 'rgba(71,85,105,0.9)',
            }}
        >
            Loading AI scenarios…
            <Skeleton active style={{ marginTop: 12 }} />
        </div>
    );
};
